import store from '@/store';
import { gcm } from '@nsftx/games-visualization-sdk/src/utility';
import socket from './socket';

export default {
  socketConnect() {
    gcm.getRoute(store.state.product.environment).then((response) => {
      socket.init(response.url, store.state.platform);
      // socket.init(response.url, store.state.platform);
      // socket.subscribe(store.state.product);
      // socket.setListeners();
      this.setConnectionListeners();
    });
  },
  setConnectionListeners() {
    window.addEventListener('offline', () => {
      // console.warn('window.addEventListener(OFFLINE)');
      // socket.disconnect();
    });
    window.addEventListener('online', () => {
      // console.warn('window.addEventListener(ONLINE)');
      socket.reconnect();
    });
  },
};
